export const isMobileDevice = (): boolean => {
  if ('userAgentData' in navigator) {
    return (navigator as any).userAgentData.mobile
  }

  const isMobileFeatures = 'ontouchstart' in window || navigator.maxTouchPoints > 0
  const isMobileScreen = window.matchMedia('(max-width: 767px)').matches

  const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

  return (isMobileFeatures && isMobileScreen) || isMobileUA
}
